export default "__VITE_ASSET__DZaVvHBv__"